import React, { useEffect, useRef } from 'react';
import { createProximityGraph } from './proximityGraph';

// Brand node colours: ember, green, blue, ochre, peach.
const NODE_PALETTE = ['225, 100, 47', '87, 204, 136', '127, 166, 196', '242, 206, 73', '245, 182, 148'];

/**
 * Hover-reactive node field painted on a canvas behind `children`. `lineColor` is an
 * "r, g, b" triplet for the connecting lines and hub (light on dark grounds, ink on paper).
 */
function NodeField({ children, reach = 240, spacing = 36, lineColor = '240, 238, 232', className = '', style }) {
  const host = useRef(null);
  useEffect(() => {
    // Purely decorative: where the browser APIs it relies on are missing (old browsers,
    // jsdom in tests) the content just sits on the plain background.
    if (typeof window.matchMedia !== 'function' || typeof window.ResizeObserver === 'undefined') return undefined;
    const graph = createProximityGraph(host.current, {
      reach,
      spacing,
      palette: NODE_PALETTE,
      color: lineColor,
      lineColor,
      hubColor: lineColor,
    });
    return () => graph.destroy();
  }, [reach, spacing, lineColor]);
  return (
    <div ref={host} className={className} style={{ position: 'relative', overflow: 'hidden', ...style }}>
      <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%' }}>{children}</div>
    </div>
  );
}

export default NodeField;
